import Topbar from "../Topbar";

/**
 * Admin shell header — white bar, pill search, ⌘K/Ctrl+K chip, bell + badge, name + role.
 * Height matches `ADMIN_HEADER_HEIGHT_PX` (sidebar header row uses the same value).
 */
const AdminHeader = () => (
  <Topbar variant="admin" searchPlaceholder="Search users, assets, analytics..." />
);

export default AdminHeader;
